import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

document.addEventListener(StandardEvents.cartLinesUpdate, event => {
  event.promise?.then(({ detail }) => {
    if (detail?.didError) return;
    const count = detail?.items?.reduce((total, item) => total + item.quantity, 0);
    if (count === undefined) return;
    document.querySelectorAll('[data-gf-live-cart-count]').forEach(badge => {
      badge.textContent = count;
      badge.hidden = count === 0;
    });
  }).catch(() => {});
});

document.addEventListener('gf:cart-added', async () => {
  try {
    const response = await fetch(`${Shopify.routes.root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cart = await response.json();
    document.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add', context: 'product', lines: [],
      promise: Promise.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { items: cart.items, itemCount: cart.item_count, source: 'botanical', didError: false },
      }),
    }));
  } catch (error) {
    console.warn('Unable to refresh the cart drawer', error);
  }
});

document.addEventListener('submit', async event => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('.gf-add-form')) return;
  if (!document.querySelector('#cart-drawer')) return;
  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  if (button.disabled) return;
  button.disabled = true;
  let status = form.querySelector('[role="status"]');
  if (!status) {
    status = document.createElement('p');
    status.setAttribute('role', 'status');
    form.append(status);
  }
  status.textContent = 'Adding…';
  try {
    const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
      method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' },
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || 'Unable to add this item. Please try again.');
    status.textContent = 'Added to your bag.';
    document.dispatchEvent(new CustomEvent('gf:cart-added'));
  } catch (error) {
    status.textContent = error.message;
  } finally {
    button.disabled = false;
  }
});
